import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { RouteI, State } from 'safe'
import { ThemeContext } from '../../context/ThemeContext'
import Tooltip from '../Display/Tooltip'
import { HiMoon, HiSun } from 'react-icons/hi'
import { FaSignOutAlt, FaUserCircle } from 'react-icons/fa'
import { AnimatePresence, AnimateSharedLayout, motion } from 'framer-motion'
import NevulaTextLogo from '../../assets/images/nevula-text.svg'
import ZeruxTextLogo from "../../assets/images/zerux-texto-blanco.svg"
import NevulaTextLogoBlue from '../../assets/images/nevula-text-blue.svg'
import LogoOnlyWhite from '../../assets/images/logo-only-white.svg'
import LogoOnlyBlue from '../../assets/images/logo-only-blue.svg'

import '../../assets/css/components/MenuList.css'
import { connect, ConnectedProps, useSelector } from 'react-redux'
import Switch from '../Inputs/Switch'
import { useOutsideClick } from '../../utils/hooks'
import { logOut } from '../../redux/actions/authentication'
import { RootState } from '../../redux/store'
import axios from 'axios'

/**
 * Componente que muestra el side menu.
 * Se llama en Dashboard.tsx.
 * @param {RouteI[]} routes rutas pertenecientes al archivo
 * routes.ts
 * @param {Function} getRoute Funcion que cambia el estado del
 * route actual en el estado perteneciente al Dashboard
 * @param {number} ulrIndex index del url actual.
 */
const server = process.env.REACT_APP_SERVER_URL
const MenuList: React.FC<MenuListProps & PropsFromRedux> = ({
  routes,
  urlIndex = 0,
  getRoute,
  collapsed,
  setCollapsed,
  logOut,
  selected,
  setSelected,
}) => {
  // const [selected, setSelected] = useState<number>(-1)
  const { theme, setTheme } = useContext(ThemeContext)

  const history = useHistory()

  const userRole = useSelector((state: RootState) => state?.auth?.user)

  const [infoAccount, setInfoAccount] = useState<any | null>(null)

  const wrapperRef = useRef(null)
  useOutsideClick(wrapperRef, () => setCollapsed(true))

  const getInfoAccount = async () => {
    let response = await axios.get(`${server}/user/tenant`)
    setInfoAccount(response?.data?.tenant)
  }

  const transform = {
    'Master': 'Master',
    'Admin': 'Admin',
    'Cashier': 'Cajero',

  }

  useEffect(() => {
    // console.log("ejecutandoo..")
    let route = history.location.pathname.split('/')
    let x = routes.findIndex((r) => r.path === route[1 + urlIndex])
    // console.log("III", x)
    setSelected(x)
    getRoute(routes[x])

    return history.listen((location) => {
      route = location.pathname.split('/')
      let index = routes.findIndex((r) => r.path === route[1 + urlIndex])
      // setSelected(index === 4 ? 3 : index)
      getRoute(routes.find((r) => r.path === route[1 + urlIndex]))
    })
    //eslint-disable-next-line
  }, [history, routes, urlIndex])

  useEffect(() => {
    // getInfoAccount()
  }, [])

  // useEffect(() => {
  //   console.log("collapsed", collapsed)
  //   if (!infoAccount?.businessSocial) {
  //     getInfoAccount()
  //   }
  // }, [collapsed])

  const handleClick = (e, path) => {
    let x = history.location.pathname.split('/')
    if (path === x[2]) e.preventDefault()
  }

  const selectBarVariants = {
    selected: { opacity: 1, height: '100%' },
    hidden: { opacity: 0, height: 0 },
  }

  const menuVariants = {
    open: {
      width: 224,
      opacity: 0.93,
      transition: {
        when: 'beforeChildren',
        staggerChildren: 0.3,
      },
    },
    closed: {
      width: 94,
      transition: {
        when: 'afterChildren',
      },
    },
  }

  const renderUl = (title, Icon, path, i) => {
    return (
      // <Tooltip
      //   key={i}
      //   title={title}
      //   position="bottom"
      //   xOffset={0}
      //   yOffset={0}
      //   show={selected === i}
      // >

      <motion.div
        className="pr-4 py-1.5 my-1 cursor-pointer w-full relative"
        onClick={() => i === 0 ? null : setSelected(i)}
      >
        {/* { selected === i && (
                            <div
                              style={{
                                height: 2,
                                background:
                                  'linear-gradient(to right, rgba(204, 214, 236, 0), rgba(255, 255, 255, 1), rgba(204, 214, 236, 0))',
                              }}
                            ></div>
                          )} */}
        <div
          className={`flex items-center py-2.5 ${
            selected === i && 'bg-primary-1300 dark:bg-primaryGray-800'
          }`}
          style={{ borderRadius: 10 }}
        >
          <motion.li
            initial=""
            animate={collapsed ? 'center' : 'start'}
            variants={{
              start: { justifyContent: 'start' },
              center: { justifyContent: 'center' },
            }}
            className={`w-full flex flex-nowrap items-center transition-transform justify-between ${
              !collapsed && 'ml-3'
            }`}
          >
            { path !== 'restaurantes' && (
              <Icon
                size="1.2rem"
                className={`text-primaryGray-light ${!collapsed && 'mr-4'}`}
              />
            )}

            {path === 'restaurantes' && (
              <img src={Icon} alt="restaurant" className={`w-5 h-5 text-primaryGray-light ${!collapsed && 'mr-4'}`} />
            )}

            {!collapsed && (
              <motion.p
                initial="hidden"
                animate="visible"
                exit="hidden"
                className={
                  'text-white capitalize font-medium tracking-wider ml-1'
                }
                variants={{
                  visible: {
                    opacity: 1,
                    transition: { delay: 0.2 },
                  },
                  hidden: {
                    opacity: 0,
                  },
                }}
              >
                {title}
              </motion.p>
            )}
          </motion.li>
        </div>
        {/* { selected === i && (
                            <div
                              style={{
                                height: 1.5,
                                background:
                                  'linear-gradient(to right, rgba(204, 214, 236, 0), rgba(255, 255, 255, 1), rgba(204, 214, 236, 0))',
                              }}
                            ></div>
                          ) } */}
        {/* {selected === i && (
                            <motion.div
                              initial="hidden"
                              animate="selected"
                              exit="hidden"
                              transition={{ duration: 0.2, ease: 'backIn' }}
                              className="absolute right-1 top-0 rounded-2xl w-1 bg-primaryGreen-light m-auto dark:bg-primary-600"
                              variants={selectBarVariants}
                            />
                          )} */}
      </motion.div>
      // </Tooltip>
    )
  }

  return (
    <div ref={wrapperRef}>
      <AnimateSharedLayout>
        <motion.div
          onMouseEnter={() => setCollapsed(false)}
          onMouseLeave={() => setCollapsed(true)}
          //responsive
          className={`h-full flex-shrink-0 bg-primary-1100 dark:bg-black flex flex-col pb-8 fixed z-50   ${
            collapsed && 'hidden lg:block'
          } ${!collapsed && 'overflow-y-scroll hide-scrollbar'}`}
          initial={false}
          animate={!collapsed ? 'open' : 'closed'}
          variants={menuVariants}
        >
          <div
            onClick={() => {
              if (
                userRole &&
                (userRole['custom:user_role'] === 'master' ||
                  userRole['custom:user_role'] === 'general_manager')
              ) {
                setCollapsed(true)
                history.push('/dashboard/dashboard/init')
              }
            }}
            className="px-6 pb-2 pt-8 w-full flex items-center flex-nowrap"
          >
            <motion.img
              className={`w-10 ${
                userRole &&
                (userRole['custom:user_role'] === 'master' ||
                  userRole['custom:user_role'] === 'general_manager') &&
                'cursor-pointer'
              }`}
              src={LogoOnlyWhite}
              alt="logo-zerux"
            />
            {!collapsed && (
              <motion.img
                className={`ml-3 w-28 ${
                  userRole &&
                  (userRole['custom:user_role'] === 'master' ||
                    userRole['custom:user_role'] === 'general_manager') &&
                  'cursor-pointer'
                }`}
                src={ZeruxTextLogo}
                alt="zerux-text-logo"
              />
            )}
          </div>
          <div className="px-6 my-5">
            <div style={{ height: 1 }} className="bg-white" />
          </div>
          {/* <div className='px-6 pb-6 pt-8 w-full mb-4 bg-gray-900 bg-opacity-10'>
          <img className='w-44' src={LogoNevulaWhite} alt='logo-nevula'/>
        </div> */}
          <AnimatePresence>
            <motion.div className="flex items-center rounded-xl bg-primary-700 dark:bg-primaryGray-dark bg-primary-1200 mx-6 shadow-md max-h-14 p-2.5">
              <motion.div>
                <FaUserCircle className="fill text-white mr-2" size="1.6rem" />
              </motion.div>
              {!collapsed && (
                <motion.div
                  style={{ maxWidth: 110 }}
                  initial="hidden"
                  animate="visible"
                  exit="hidden"
                  variants={{
                    visible: {
                      opacity: 1,
                      transition: { delay: 0.2 },
                    },
                    hidden: {
                      opacity: 0,
                    },
                  }}
                >
                  <motion.p className="text-white font-medium tracking-wide capitalize truncate">
                    {(userRole && userRole['custom:real_name']) || ''}
                  </motion.p>

                  <motion.p className="text-primaryGreen-light text-xs font-light dark:text-primary-500 font-bold truncate">
                    {transform[(userRole &&
                      ((role) =>`${role[0].toUpperCase()}${role.slice(1)}`)(
                        userRole['custom:user_role']
                      ))] || ''}
                  </motion.p>
                </motion.div>
              )}
            </motion.div>
          </AnimatePresence>
          <motion.div
            layout
            className="h-full flex flex-col flex-grow pl-6 mt-4"
          >
            <motion.ul>
              {routes.map(
                ({ title, icon: Icon, path, disabled, tooltipMessage }, i) => {
                  // console.log("VIENDOO...", tooltipMessage)
                  if (!disabled) {
                    if (tooltipMessage) {
                      return (
                        <Tooltip
                          key={i}
                          title={''}
                          position="top"
                          xOffset={0}
                          yOffset={0}
                          show={true && !collapsed}
                          componentValue={tooltipMessage}
                        >
                          {renderUl(title, Icon, path, i)}
                        </Tooltip>
                      )
                    }
                    return (
                      <AnimatePresence key={path}>
                        <Link
                          to={
                            !Array.isArray(path)
                              ? `/dashboard/${path}`
                              : `/dashboard/${path[0]}`
                          }
                          onClick={(e) => handleClick(e, path)}
                        >
                          {renderUl(title, Icon, path, i)}
                        </Link>
                      </AnimatePresence>
                    )
                  }
                }
              )}

              <AnimatePresence>
                <motion.div className="pr-4 py-1.5 my-1 ml-2 cursor-pointer w-full relative mt-4">
                  <motion.li
                    initial=""
                    animate={collapsed ? 'center' : 'start'}
                    variants={{
                      start: { justifyContent: 'start' },
                      center: { justifyContent: 'center' },
                    }}
                    className="w-full flex flex-nowrap items-center transition-transform"
                  >
                    <Switch
                      small={true}
                      onChange={(darkModeOn: boolean) =>
                        setTheme(darkModeOn ? 'dark' : 'light ')
                      }
                      icon={theme === 'dark' ? <HiSun /> : <HiMoon />}
                      value={theme === 'dark' ? true : false}
                      switchClasses={
                        'dark:bg-white dark:hover:bg-white dark:focus:bg-white dark:checked:border-border-black'
                      }
                    />
                    {!collapsed && (
                      <motion.p
                        initial="hidden"
                        animate="visible"
                        exit="hidden"
                        className="capitalize font-medium tracking-wider text-white ml-1"
                        variants={{
                          visible: {
                            opacity: 1,
                            transition: { delay: 0.2 },
                          },
                          hidden: {
                            opacity: 0,
                          },
                        }}
                      >
                        Modo oscuro
                      </motion.p>
                    )}
                  </motion.li>

                  <div
                    className={`flex items-center mt-10 ml-1 ${
                      collapsed && 'ml-4'
                    }`}
                  >
                    <FaSignOutAlt className="text-primaryGray-light" />
                    {!collapsed && (
                      <motion.p
                        onClick={() => {
                          let keys = Object.keys(localStorage)
                          keys.forEach((key) => {
                            if (/^CognitoIdentityServiceProvider/.test(key)) {
                              localStorage.removeItem(key)
                            }
                          })
                          localStorage.removeItem('credentials')
                          localStorage.removeItem('nevulaAdvice')
                          history.push('/ingresar')
                          localStorage.setItem('color-theme', 'light')

                          let widget = document.getElementById("fc_widget")

                          if (widget) {
                            widget.style.display = 'inherit'
                          }

                          logOut()
                        }}
                        initial="hidden"
                        animate="visible"
                        exit="hidden"
                        className="capitalize font-medium tracking-wider ml-6 text-white"
                        variants={{
                          visible: {
                            opacity: 1,
                            transition: { delay: 0.2 },
                          },
                          hidden: {
                            opacity: 0,
                          },
                        }}
                      >
                        Cerrar sesión
                      </motion.p>
                    )}
                  </div>
                </motion.div>
              </AnimatePresence>
            </motion.ul>
          </motion.div>
          {/* <div className='flex items-center justify-center rounded-xl bg-gray-900 bg-opacity-10 hover:bg-opacity-20 mx-6 px-4 py-2 cursor-pointer'
          onClick={() => (console.log("Presiona") , setCollapsed(!collapsed) )}
        >
          <div>{!collapsed 
            ? <HiOutlineChevronDoubleLeft size='1.4rem' className='text-white'/> 
            : <HiOutlineChevronDoubleRight size='1.4rem' className='text-white'/>}
          </div>
        </div> */}
        </motion.div>
      </AnimateSharedLayout>
    </div>
  )
}

const mapState = ({ auth }: State) => ({ auth })

const connector = connect(mapState, { logOut })

export default connector(MenuList)

interface MenuListProps {
  routes: RouteI[]
  urlIndex?: number
  getRoute?: any
  collapsed: boolean
  setCollapsed: Function
  selected: number
  setSelected: Function
}

type PropsFromRedux = ConnectedProps<typeof connector>
